import React from "react";
import { Box, Card, CardMedia, Typography } from "@mui/material";

import AppNavigation from "../navigation/AppNavigation";

const Card17Image = ({ card }) => {
 
const { handleNavigation } = AppNavigation();
const handleCardClick = (index) => {
  const onTap = card.cardData[index]?.data?.onTap;
  console.log("onTap", onTap);
  if (!onTap) {
    console.log("No onTap data found in card.");
    return;
  }
  handleNavigation(onTap); // Pass onTap to the navigation handler
};
  return (
  <Box sx={{ marginBottom: 3 }} key={card.cardMetaData?.id}>
    {card.cardMetaData?.title && (
      <Typography
        variant="h6"
        sx={{
          marginBottom: 1,
          fontWeight: "bold",
          fontSize: "16px",
          color: "#333",
        }}
      >
        {card.cardMetaData.title}
      </Typography>
    )}

    <Box
      sx={{
        display: "flex",
        gap: 2,
        overflowX: "auto",
        padding: "8px 0",
      }}
    >
      {card.cardData.map((item, idx) => (

        <Card
          key={idx}
          onClick={() => handleCardClick(idx)}
          sx={{
            minWidth: 110,
            height: 110,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
          }}
        >
          <CardMedia
            component="img"
            image={item.data.imageUrl}
            alt={item.data.displayName}
            sx={{
              width: 110,
              height: 110,
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Card>
      ))}
    </Box>
  </Box>
);
};

export default Card17Image;